var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from '@/events/AppEvents';
import { Apphandler } from '@/ipc/MainAppHandler';
import { Box, Checkbox, Flex, Icon, Input, InputGroup, InputLeftElement, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { FaUser } from '@react-icons/all-files/fa/FaUser';
import { FcBusinessContact } from '@react-icons/all-files/fc/FcBusinessContact';
import { FcSearch } from '@react-icons/all-files/fc/FcSearch';
import { action, makeObservable, observable } from 'mobx';
import { Observer, observer } from 'mobx-react';
import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { Virtuoso } from 'react-virtuoso';
import { BaseDialog, BaseDialogState } from './BaseDialog';
export class OrgContactListState {
    constructor() {
        this.open = false;
        this.reload = true;
        this.dialogsate = new BaseDialogState();
        this.selectedcontactmap = new Map();
        this.selectedContacts = new Set();
        this.loading = false;
        this.loadingmore = false;
        // callee should add this as per sorting req....
        this.contacts = [];
        this.filterString = "";
        this.showselected = false;
        this.showunselected = false;
        makeObservable(this);
        this.dialogsate.setHeaderLabel("External Contacts");
        this.dialogsate.setOkLabel("Done");
        this.dialogsate.setCancelLabel("Cancel");
        this.dialogsate.onClose = () => {
            this.resetSelectedContact();
        };
        this.dialogsate.onOk = () => {
            this.dialogsate.setOpen(false);
        };
        APPEvent.addSubscriberForOrgContacts((cts) => {
            if (this.loading || this.loadingmore) {
                this.addOrgContacts(cts);
                this.setLoading(false);
                this.setLoadingMore(false);
            }
        });
    }
    setFilterString(input) {
        this.filterString = input;
    }
    addOrgContacts(conts) {
        conts.forEach((c) => this.contacts.push(c));
    }
    resetFilter() {
        this.setFilterString("");
        this.setShowAllItems();
    }
    setShowAllItems() {
        this.setFilterString("");
        this.showselected = false;
        this.showunselected = false;
    }
    setShowSelected() {
        this.setFilterString("");
        this.showselected = true;
        this.showunselected = false;
    }
    setShowUnSelected() {
        this.setFilterString("");
        this.showunselected = true;
        this.showselected = false;
    }
    reset() {
        this.setLoading(false);
        this.setLoadingMore(false);
        this.selectedContacts.clear();
        this.contacts = [];
        this.selectedcontactmap.clear();
        this.resetFilter();
        this.setShowAllItems();
    }
    resetSelectedContact() {
        var _a;
        this.selectedContacts.clear();
        this.selectedcontactmap.clear();
        (_a = this.onSelecCb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    loadMore() {
        this.setLoadingMore(true);
        this.loadOrgContacts();
    }
    loadOrgContacts() {
        const lastch = this.contacts.length > 0 ? this.contacts[this.contacts.length - 1].name : "";
        const req = {
            lastch: lastch
        };
        Apphandler.sendMessage("getorgcontacts", req);
    }
    setOpen(open) {
        if (open && this.reload) {
            this.reload = false;
            this.setLoading(true);
            this.loadOrgContacts();
        }
        this.open = open;
        this.dialogsate.setOpen(open);
    }
    setLoadingMore(loading) {
        this.loadingmore = loading;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    // maybe we should tell other side about this as well
    setSelectedContact(cont) {
        var _a;
        if (this.selectedContacts.has(cont.id)) {
            this.selectedContacts.delete(cont.id);
            this.selectedcontactmap.delete(cont.id);
        }
        else {
            this.selectedContacts.add(cont.id);
            this.selectedcontactmap.set(cont.id, cont);
        }
        (_a = this.onSelecCb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    getSelectedContact() {
        return Array.from(this.selectedcontactmap.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", BaseDialogState)
], OrgContactListState.prototype, "dialogsate", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], OrgContactListState.prototype, "selectedcontactmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], OrgContactListState.prototype, "selectedContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "loadingmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], OrgContactListState.prototype, "contacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "filterString", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "showselected", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OrgContactListState.prototype, "showunselected", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setFilterString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "addOrgContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "resetFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setShowAllItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setShowSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setShowUnSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "resetSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], OrgContactListState.prototype, "setLoading", null);
let OrgContactList = class OrgContactList extends React.Component {
    constructor(prop) {
        super(prop);
    }
    drawContact(con) {
        return React.createElement(Flex, { className: 'contacts-table-row', key: con.id, backgroundColor: this.props.state.selectedContacts.has(con.id) ? '#F2F5FF' : '#FFFFFF' },
            React.createElement(Flex, { _hover: { cursor: 'pointer' }, justifyContent: 'center', alignItems: 'center', style: {
                    borderRadius: 22, width: 30, height: 30, borderWidth: '1px',
                } },
                React.createElement(Icon, { color: 'orange', as: FaUser, w: '20px', h: '20px' })),
            React.createElement(Flex, { width: '90%', ml: '10px' },
                React.createElement(Text, { fontSize: '16px' }, con.name)),
            React.createElement(Flex, { justifyContent: 'flex-end' },
                React.createElement(Checkbox, { defaultChecked: this.props.state.selectedContacts.has(con.id), onChange: (e) => this.props.state.setSelectedContact(con) })));
    }
    loadMore() {
    }
    dialog() {
        let filteredContacts = this.props.state.contacts;
        if (this.props.state.showselected) {
            filteredContacts = filteredContacts.filter(grp => this.props.state.selectedContacts.has(grp.id));
        }
        else if (this.props.state.showunselected) {
            filteredContacts = filteredContacts.filter(grp => !this.props.state.selectedContacts.has(grp.id));
        }
        if (this.props.state.filterString) {
            filteredContacts = filteredContacts.filter(grp => grp.name.toLowerCase().indexOf(this.props.state.filterString.toLowerCase()) > -1);
        }
        return React.createElement(Box, { minHeight: '300px' },
            this.props.state.loading && React.createElement(Flex, { justify: 'center', align: 'center', h: '100%', w: '100%' },
                React.createElement(ScaleLoader, { color: 'green' })),
            !this.props.state.loading && React.createElement(Box, null,
                this.props.state.contacts.length === 0 && React.createElement(Text, null, "Found no organisation Contacts"),
                React.createElement(Box, { style: { marginTop: 10, marginBottom: 10 } },
                    React.createElement(RadioGroup, { defaultValue: this.props.state.showselected ? '2' : '1' },
                        React.createElement(Radio, { colorScheme: 'green', value: '1', onChange: (e) => this.props.state.setShowAllItems(), style: { marginLeft: 10 } }, "All"),
                        React.createElement(Radio, { colorScheme: 'green', value: '2', onChange: (e) => this.props.state.setShowSelected(), style: { marginLeft: 10 } }, "Selected"),
                        React.createElement(Radio, { colorScheme: 'green', value: '3', onChange: (e) => this.props.state.setShowUnSelected(), style: { marginLeft: 10 } }, "Unselected"))),
                React.createElement(Box, { mt: '10px', mb: '10px' },
                    React.createElement(InputGroup, null,
                        React.createElement(InputLeftElement, { pointerEvents: 'none', children: React.createElement(Icon, { as: FcSearch, w: '30px', h: '30px' }) }),
                        React.createElement(Input, { placeholder: 'Search', value: this.props.state.filterString, onChange: (e) => this.props.state.setFilterString(e.target.value) }))),
                filteredContacts.length === 0 && React.createElement(Flex, { flexDirection: 'column', w: '100%', h: '100%', justify: 'center', align: 'center' },
                    React.createElement(Icon, { h: '3em', w: '30px', as: FcBusinessContact }),
                    React.createElement(Text, null, "No contacts found")),
                filteredContacts.length > 0 &&
                    React.createElement(Observer, null, () => React.createElement(Virtuoso, { style: { height: "400px", }, data: filteredContacts, itemContent: (index, ec) => this.drawContact(ec) }))));
    }
    render() {
        return React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.dialogsate });
    }
};
OrgContactList = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], OrgContactList);
export { OrgContactList };
